export enum DesifTipoPartidaEnum {

  CREDITO,
  DEBITO,
  CREDITO_DEBITO
}
